var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceIconCreateInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.5 30.57H52.83C45.72 30.57 39.93 24.78 39.93 17.67V9C39.93 7.35 38.58 6 36.93 6H24.21C14.97 6 7.5 12 7.5 22.71V49.29C7.5 60 14.97 66 24.21 66H47.79C57.03 66 64.5 60 64.5 49.29V33.57C64.5 31.92 63.15 30.57 61.5 30.57Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4 6.62998C46.17 5.39998 44.04 6.23998 44.04 7.94998V18.42C44.04 22.8 47.76 26.43 52.29 26.43C55.14 26.46 59.1 26.46 62.49 26.46C64.2 26.46 65.1 24.45 63.9 23.25C59.58 18.9 51.84 11.07 47.4 6.62998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 41.25H22.5C21.27 41.25 20.25 40.23 20.25 39C20.25 37.77 21.27 36.75 22.5 36.75H40.5C41.73 36.75 42.75 37.77 42.75 39C42.75 40.23 41.73 41.25 40.5 41.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 53.25H22.5C21.27 53.25 20.25 52.23 20.25 51C20.25 49.77 21.27 48.75 22.5 48.75H34.5C35.73 48.75 36.75 49.77 36.75 51C36.75 52.23 35.73 53.25 34.5 53.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIconCreateInvoice);
export default __webpack_public_path__ + "static/media/invoice_icon_create_invoice.1953389eabd457e44d29759f310d56c0.svg";
export { ForwardRef as ReactComponent };